import HelpButton from "../common/buttons/HelpButton";

export default function PageTitle({
  children = null,
  title,
  onClick = () => {},
  id = "",
  showHelpButton = false,
  alignChildren = "right",
}) {
  return (
    <div className="flex flex-row items-center mt-6 mb-2 relative">
      <div className="flex items-center space-x-4">
        <h1
          className="text-left text-gray-700 dark:text-gray-300"
          data-testid={`page-title-${title}`}
        >
          {title}
        </h1>
        {alignChildren === "left" && children}
      </div>
      <div className="flex items-center space-x-2 ml-auto">
        {alignChildren === "right" && children}
        {showHelpButton && <HelpButton id={id} onClick={onClick} />}
      </div>
    </div>
  );
}
